// extracted by mini-css-extract-plugin
export default {"row":"TableRow-row-lgbLy"};